import React from "react";
import Svg, { Path } from "react-native-svg";

const CLAppLogo = (props) => (
  <Svg
    width="30"
    height="30"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
      fill="black"
    />
    <Path
      d="M16.2282 13.5938C16.2282 14.9803 15.6774 16.31 14.697 17.2905C13.7166 18.2709 12.3868 18.8217 11.0003 18.8217C9.61372 18.8217 8.28396 18.2709 7.30353 17.2905C6.3231 16.31 5.77229 14.9803 5.77229 13.5938H8.44916C8.44916 14.2703 8.71794 14.9192 9.19636 15.3976C9.67479 15.8761 10.3237 16.1448 11.0003 16.1448C11.6769 16.1448 12.3257 15.8761 12.8042 15.3976C13.2826 14.9192 13.5514 14.2703 13.5514 13.5938H16.2282Z"
      fill="white"
    />
    <Path
      d="M9.66206 6.02246C9.66164 6.02964 9.66164 6.03684 9.66206 6.04402V6.02246Z"
      fill="white"
    />
    <Path
      d="M16.2279 6.0228C16.2203 5.42084 16.0473 4.83257 15.7279 4.3223C15.4084 3.81204 14.9548 3.39942 14.4167 3.12957C13.8785 2.85972 13.2766 2.74302 12.6766 2.79223C12.0766 2.84145 11.5017 3.05468 11.0147 3.40862C10.5277 3.04602 9.94976 2.82556 9.34502 2.77172C8.74028 2.71789 8.13245 2.83279 7.5891 3.10366C7.04574 3.37454 6.58813 3.79077 6.26713 4.3061C5.94612 4.82143 5.7743 5.41568 5.77075 6.0228C5.77075 6.02977 5.77075 6.03673 5.77075 6.0437V11.9202H8.44721V6.04288H8.45213C8.45213 5.88327 8.51554 5.73019 8.6284 5.61732C8.74126 5.50446 8.89434 5.44105 9.05396 5.44105C9.21357 5.44105 9.36665 5.50446 9.47951 5.61732C9.59237 5.73019 9.65578 5.88327 9.65578 6.04288H9.66029V6.02199C9.65988 6.02894 9.65988 6.03592 9.66029 6.04288C9.66029 6.04984 9.66029 6.05681 9.66029 6.06377V11.9202H12.3372V6.06459H12.3417C12.3417 5.90498 12.4051 5.7519 12.5179 5.63904C12.6308 5.52617 12.7839 5.46277 12.9435 5.46277C13.1031 5.46277 13.2562 5.52617 13.369 5.63904C13.4819 5.7519 13.5453 5.90498 13.5453 6.06459H13.5502V11.9202H16.2267V6.06459C16.2283 6.05066 16.2283 6.03673 16.2279 6.0228ZM12.3388 6.0437C12.3388 6.03673 12.3388 6.02977 12.3388 6.0228V6.0437Z"
      fill="white"
    />
    <Path
      d="M9.66206 6.02246C9.66164 6.02955 9.66164 6.03666 9.66206 6.04376C9.66206 6.05085 9.66206 6.05795 9.66206 6.06505V6.02246Z"
      fill="white"
    />
  </Svg>
);

export default CLAppLogo;
